<template>

  <div :style="mapStyle">
    <l-map
      v-if="show && null!=zoom"
      ref="map"
      :key="'map'+invalidateCounter"
      :zoom="zoom"
      :center="center"
      :max-bounds="maxBounds"
      :options="mapOptions"
      style="height: 100%;"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @click="addMarker"
    >

      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <!-- Listed companies -->
      <v-marker-cluster :options="{singleMarkerMode:singleMarkerMode,showCoverageOnHover: false,iconCreateFunction:clusterImg,polygonOptions:{ weight: 0.5, color: '#222', opacity: 0.5 }}">
      <l-marker v-for="(item,index) in itemsWithPosition"  :key="index" :lat-lng="getPosByItem(item)" :icon="icon">
        <l-popup v-if="item">
          <div @click="openShop(item)">
            <b>{{item.title}}</b>
            <p>
              {{item.descr}}
            </p>
            <p>
              <center><img :src="getModifiedImage(item.img)" style="max-width:200px;max-height:100px;"></center>
            </p>
            <p class="text-center">
              <router-link :to="`/shop/${removeSpecialCharsFromString(item.title)}`" class="primary-color">>> Mehr erfahren >></router-link>
              </p>
          </div>
        </l-popup>
      </l-marker>
      </v-marker-cluster>

      <!-- Clicked Positions -->
      <l-marker v-if="clickedPosition" :lat-lng="clickedPosition.latlng" :icon="icon"></l-marker>
    </l-map>
  </div>
</template>

<script>
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import {latLng, icon,DivIcon,Point } from "leaflet";// latLngBounds,
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import {helper} from '@/mixins/helper.js'
//import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
//import 'leaflet-fullscreen/dist/Leaflet.fullscreen';

export default {
  name: "RTMap",
  mixins:[helper],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props:{
    show:{
      type:Boolean,
      default:true
    },
    enableInput:{
      type:Boolean,
      default:false
    },
    items:{
      type:Array
    },
    height:{
      type:String,
      default:"400px"
    },
    width:{
      type:String,
      default:"100%"
    },
    initialZoom:{
      type:Number,
      default:12
    },
    singleMarkerMode:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      invalidateCounter:0,
      zoom: null,
      center: latLng(50.927798, 11.587548),
      token:"154dac24-972a-49a5-b6f0-2943be0348b3",
      url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key='+this.token, //https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png
      attribution:
        '&copy; <a target="_blank" href="https://stadiamaps.com">Stadia Maps</a>',
      currentZoom: 18,
      currentCenter: latLng(50.927798, 11.587548),
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 18,
        minZoom:2
      },
      icon: icon({
        iconUrl: "/images/heart.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32]
      }),
      maxBounds: null,
      clickedPosition:null
    };
  },
  watch:{
    initialZoom: {
      handler(val) {
        this.zoom=val;
      },
      immediate: true
    }
  },
  computed:{
    mapStyle(){
      return `height: ${this.height}; width: ${this.width};`;
    },
    itemsWithPosition(){
      return this._.filter(this.items,(shop)=>{
        return this.hasPosition(shop);
      })
    }
  },
  methods: {
     
    clusterImg: function (cluster) {
      var childCount = cluster.getChildCount();

      var c = ' marker-cluster-';
      if (childCount < 10) {
        c += 'small';
      } else if (childCount < 100) {
        c += 'medium';
      } else {
        c += 'large';
      }

      return new DivIcon({ html: '<div class="customClusterMarker"><span>' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new Point(40, 40) });
    },
    addMarker(e) {
      if(this.enableInput && e){
        this.clickedPosition={latlng: e.latlng};
        this.$emit('updatePosition',e.latlng);
      }
    },
    getPosByItem(item){

      if(this.hasPosition(item)){
        return latLng(Number(item.lat),Number(item.lng))
      }else{
        console.log('Shop without location');
        console.log(item);
      }
      return latLng(0,0);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    openShop(item) {
      if(item){
        //this.closeFullScreenMap();
        this.$router.push({ name: 'shop', params: { id: this.removeSpecialCharsFromString(item.title) } })
      }
    },
    hasPosition(item){
      return (item && !isNaN(item.lat) && !isNaN(item.lng))
    },
    getMap(){
      return (this.$refs.map)?this.$refs.map.mapObject:null;
    },
    closeFullScreenMap(){
      const map=this.getMap();
      if(map && map.isFullscreen()){
        map._setFullscreen(false);
        //this.invalidateCounter++;
        //map.toggleFullScreen();
      }
    },
    addFullscreenPlugin(){
      const map=this.getMap();
      if(map){
          map.addControl(new window.L.Control.Fullscreen());
          map.on('fullscreenchange', function () {
          if (map.isFullscreen()) {
              console.log('entered fullscreen');
          } else {
              console.log('exited fullscreen');
          }
        });
      }
    }
  },
  mounted(){
    if(this.items && this.items.length==1){
      this.center=latLng(this.items[0].lat,this.items[0].lng)
    }
    //this.addFullscreenPlugin();

    /*setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);*/
    //setTimeout(()=>{this.mapComponentKey++}, 500);
  },
  
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.marker-cluster-small,.marker-cluster-small div,.marker-cluster-medium,.marker-cluster-medium div,.marker-cluster-large,.marker-cluster-large div{
    background-color: rgba(0,0,0,0)!important;
    color:white!important;
}
.leaflet-marker-icon{
    background-image: url("/images/heart.png")!important;
    background-size: contain;
    background-repeat: no-repeat;
}
</style>